/* istanbul ignore file */
import { css } from 'styled-components';
export var scrollableContent = /*#__PURE__*/css(["flex-shrink:1;flex-grow:1;overflow-y:scroll;"]);